import BankCard from './bank-card';

export default BankCard;
